import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { getDepartmentList, getDepartmentInfo } from '@/service/proRequisition';
import { showLoadingToast } from 'vant';
export default function userList() {
  var firstLoad = ref(true);
  var list = ref([]);
  var getDepartmentListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var toast, data, _list$value;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            toast = null;
            _context.prev = 1;
            toast = showLoadingToast({
              message: '加载中...',
              forbidClick: true,
              duration: 0
            });
            _context.next = 5;
            return getDepartmentList();
          case 5:
            data = _context.sent;
            if (Array.isArray(data)) {
              (_list$value = list.value).push.apply(_list$value, _toConsumableArray(data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  name: item.dept_name,
                  user: false
                });
              })));
              firstLoad.value = false;
            }
          case 7:
            _context.prev = 7;
            setTimeout(function () {
              // closeToast();
              toast.close();
            });
            return _context.finish(7);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1,, 7, 10]]);
    }));
    return function getDepartmentListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getDepartmentInfoAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
      var toast, data, _list$value2;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            toast = null;
            _context2.prev = 1;
            toast = showLoadingToast({
              message: '加载中...',
              forbidClick: true,
              duration: 0
            });
            _context2.next = 5;
            return getDepartmentInfo(params);
          case 5:
            data = _context2.sent;
            if (Array.isArray(data)) {
              (_list$value2 = list.value).push.apply(_list$value2, _toConsumableArray(data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  name: item.data_type === 1 ? item.name : item.dept_name,
                  user: item.data_type === 1 ? true : false // data_type  1员工 2部门
                });
              })));
              firstLoad.value = false;
            }
          case 7:
            _context2.prev = 7;
            setTimeout(function () {
              toast.close();
            });
            return _context2.finish(7);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1,, 7, 10]]);
    }));
    return function getDepartmentInfoAsync(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return [firstLoad, list, getDepartmentListAsync, getDepartmentInfoAsync];
}